'use strict';

var base = require('core/blog/blog');

base.positionStickyHeader = function() {
    if ($('.blog-detail-header-sticky').length > 0) {
        var $stickyHeader = $('.blog-detail-header-sticky');
        var headerHeight = $('#top-header').outerHeight();
        var blogHeaderHeight = $('.blog-detail-header').outerHeight();

        $stickyHeader.css('top', headerHeight + 'px');

        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            if (scrollTop > blogHeaderHeight) {
                if (!$stickyHeader.hasClass('visible')) {
                    $stickyHeader.addClass('visible');
                }
            } else {
                if ($stickyHeader.hasClass('visible')) {
                    $stickyHeader.removeClass('visible');
                }
            }
        });
    }
};

module.exports = base;
